import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { OKTA_AUTH } from '@okta/okta-angular';
import { AuthService } from '../services/auth/auth.service';

export const authGuard: CanActivateFn = async (): Promise<boolean | UrlTree> => {
  const oktaAuth = inject(OKTA_AUTH);
  const authService = inject(AuthService);
  const router = inject(Router);

  const isAuthenticated = await oktaAuth.isAuthenticated();

  if (!isAuthenticated) {
    // Send anonymous visitors to the sign-in screen rather than straight into
    // signInWithRedirect(). Every protected route is now reachable from the
    // guarded root, and Okta's sign-out returns to that root, so redirecting to
    // Okta from here would turn "Sign out" into an instant re-prompt the user
    // cannot escape — and would leave the Login screen unreachable. Login owns
    // the hand-off to Okta; AuthService.initialize() sends staff on to '/'
    // once they come back.
    return router.parseUrl('/login');
  }

  if (!authService.currentUser()?.isActive) {
    return router.parseUrl('/unauthorized');
  }

  return true;
};
